import React, { useEffect, useState } from 'react';
import {
  Upload as UploadIcon,
  FileText,
  X,
  RussianRuble,
  Eye,
  Info,
  AlertCircle,
  Upload,
  Image,
  AlertTriangle
} from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardHeader, CardTitle, CardContent } from './ui/card';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Badge } from './ui/badge';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from './ui/select';
import SunEditor from 'suneditor-react';
import { API_URL } from '../config';
import { authFetch } from '../utils/authFetch';


const DocumentUpload = () => {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');
  const [uploading, setUploading] = useState(false);

  const [title, setTitle] = useState('');
  const [price, setPrice] = useState('');
  const [category, setCategory] = useState('');
  const [description, setDescription] = useState('');
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  const [hasCard, setHasCard] = useState();

  const categories = [
    { id: 'workCult', name: 'Культура работы' },
    { id: 'projManag', name: 'Управление проектами' },
    { id: 'operEff', name: 'Операционная эффективность' },
    { id: 'hr', name: 'HR' },
    { id: 'demandPlann', name: ' Планирование потребности' },
    { id: 'provisPlann', name: 'Планирование обеспечения' },
    { id: 'purch', name: 'Закупки' },
    { id: 'logic', name: 'Логистика' },
    { id: 'money', name: 'Финансы' },
    { id: 'nsi', name: 'Развитие НСИ' },
    { id: 'automat', name: 'Автоматизация' },
    { id: 'strat', name: 'Стратегия' }
  ];

  useEffect(() => {
    const hasCard = async () => {
       try {
        const token = localStorage.getItem('token');
        const res = await authFetch(`${API_URL}/seller/has-payout-card`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        const data = await res.json();
        setHasCard(data.hasCard);
      } catch (err) {
        console.error('Ошибка при получении данных пользователя:', err);
      }
    }
    hasCard();

  }, []);



  const handleFileChange = e => {
    // сохраняем сам File
    setFile(e.target.files[0]);
    setMessage('');
  };

  const handleUpload = async e => {
    e.preventDefault();
    if (!file || !title || !price || !category) {
      return setMessage('Заполните все обязательные поля');
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('title', title);
    formData.append('price', price);
    formData.append('category', category);
    formData.append('description', description);
    formData.append('image', image);

    try {
      setUploading(true);
      const token = localStorage.getItem('token');
      const response = await authFetch(`${API_URL}/documents`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
          // note: do NOT set Content-Type; letting browser set multipart boundary
        },
        body: formData
      });

      if (!response.ok) {
        throw new Error(`Server responded ${response.status}`);
      }

      setMessage('✅ Документ успешно загружен и отправлен на модерацию');
      setFile(null);
      setTitle('');
      setPrice('');
      setCategory('');
      setDescription('');
      setImage(null);
      setImagePreview(null);
    } catch (err) {
      console.error(err);
      setMessage('❌ Ошибка загрузки');
    } finally {
      setUploading(false);
    }
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB', 'GB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
  }

  const removeFile = () => {
    setFile(null);
  };

  const handleImageChange = (e) => {
    if (!e.target.files?.length) return
    const img = e.target.files[0]
    setImage(img)
    setImagePreview(URL.createObjectURL(img))
  }

  const calculatedEarnings = price ? (parseFloat(price) * 0.85).toFixed(0) : '0'

  return (
    <div className="max-w-6xl mx-auto p-6 space-y-6">
      {/* Header */}
      <div className="text-center space-y-2">
        <h1 className="gradient-text text-3xl font-bold">Загрузка документа</h1>
        <p className="text-gray-600">
          Загрузите ваш документ и начните зарабатывать уже сегодня
        </p>
      </div>
      <form onSubmit={handleUpload} className="space-y-6" encType="multipart/form-data">
          {/* File Upload Area */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Upload className="h-5 w-5" />
              Выберите файлы
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div
              className={`
                relative border-2 border-dashed rounded-lg p-8 text-center transition-colors
              `}
            >
              <Upload className="h-12 w-12 text-gray-400 mx-auto mb-4" />
              <p className="text-lg font-medium text-gray-700 mb-2">
                Нажмите для выбора файла
              </p>
              <input
                type="file"
                onChange={handleFileChange}
                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
              />
              <Button type="button" variant="outline">
                Выбрать файлы
              </Button>
            </div>


                {file && (
              <div className="mt-6 space-y-3">
                <Label>Загруженные файлы:</Label>
                  <div
                    key={file.id}
                    className="flex items-center justify-between p-3 bg-gray-50 rounded-lg border"
                  >
                    <div className="flex items-center gap-3">
                      <FileText className="h-5 w-5 text-blue-600" />
                      <div>
                        <p className="font-medium text-sm">{file.name}</p>
                        <p className="text-xs text-gray-500">
                          {formatFileSize(file.size)}
                        </p>
                      </div>
                    </div>
                    <Button
                      type="button"
                      variant="ghost"
                      size="sm"
                      onClick={removeFile}
                      className="text-red-600 hover:text-red-700 hover:bg-red-50"
                    >
                      <X className="h-4 w-4" />
                    </Button>
                  </div>
              </div>
            )}


          </CardContent>
        </Card>

        {/* Document Information */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Info className="h-5 w-5" />
              Информация о документе
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label htmlFor="title">Название документа *</Label>
                <Input
                  id="title"
                  placeholder="Введите название документа"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  required
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="category">Категория *</Label>
                <Select value={category} onValueChange={setCategory} required>
                  <SelectTrigger>
                    <SelectValue placeholder="Выберите категорию" />
                  </SelectTrigger>
                  <SelectContent>
                    {categories.map((cat) => (
                      <SelectItem key={cat.id} value={cat.id}>
                        {cat.name}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label htmlFor="price">Цена (₽) *</Label>
                <div className="relative">
                  <RussianRuble className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
                  <Input
                    id="price"
                    type="number"
                    placeholder="199"
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                    className="pl-10"
                    min="1"
                    required
                  />
                </div>
              </div>
              <div className="space-y-2">
                <Label>Ваш доход</Label>
                <div className="flex items-center gap-2 p-3 bg-green-50 rounded-lg border border-green-200">
                  <Eye className="h-4 w-4 text-green-600" />
                  <span className="font-medium text-green-700">
                    {calculatedEarnings}₽ (85% от цены)
                  </span>
                </div>
                <p className='text-gray-700 text-[8px]'>
                  15% -комиссия сервиса с продажи (включая банковские сервисы и налоги)
                </p>
              </div>
            </div>
            <div className="space-y-2">
              <Label htmlFor="description">Описание (опционально)</Label>
              <SunEditor
                height="200px"
                setOptions={{
                  buttonList: [
                    ['undo', 'redo'],
                    ['formatBlock'],                // заголовки
                    ['bold', 'italic', 'underline'],
                    ['list'],          // списки
                    ['align', 'lineHeight'],        // выравнивание
                    ['link', 'image'],              // ссылки и картинки
                    ['removeFormat', 'fullScreen']  // сброс и полноэкранный режим
                  ],
                  charCounter: true,        // отображать счётчик
                  maxCharCount: 3000 // лимит
                }}
                setContents={description}
                onChange={setDescription}
                placeholder="Опишите содержание документа..."
              />
          </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Image /> Превью (jpg, png, svg,…)
            </CardTitle>
          </CardHeader>
          <CardContent>
            <label className="block border rounded p-4 text-center cursor-pointer hover:border-gray-400">
              <Image className="mx-auto mb-2 h-6 w-6 text-gray-400" />
              <p className="text-gray-600">Выберите изображение 236×150</p>
              <input
                type="file"
                accept="image/*"
                className="hidden"
                onChange={handleImageChange}
              />
            </label>
            {imagePreview && (
              <img
                src={imagePreview}
                alt="Preview"
                className="mt-3 max-h-40 rounded border"
              />
            )}
          </CardContent>
        </Card>

        {/* Submit Button */}
        <div className="flex justify-center">
          <Button
            type="submit"
            disabled={uploading}
            className="bg-gradient-to-r from-[#3466F8] via-[#CF4EE6] to-[#F6275D] hover:opacity-90 text-white border-0 px-8 py-3"
          >
            <Upload className="h-4 w-4 mr-2" />
            Загрузить документ
          </Button>
        </div>
      </form>
      {message && (
        <p className="mt-2 text-sm text-gray-700">{message}</p>
      )}

      {/* Tips */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-lg">
            <AlertCircle className="h-5 w-5" />
            Советы для успешной продажи
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <Badge className="bg-green-100 text-green-800 border-green-200 mt-1">1</Badge>
                <div>
                  <p className="font-medium">Качественное оформление</p>
                  <p className="text-sm text-gray-600">Проверьте форматирование и исправьте ошибки</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Badge className="bg-blue-100 text-blue-800 border-blue-200 mt-1">2</Badge>
                <div>
                  <p className="font-medium">Понятное название</p>
                  <p className="text-sm text-gray-600">Используйте ключевые слова для поиска</p>
                </div>
              </div>
            </div>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <Badge className="bg-purple-100 text-purple-800 border-purple-200 mt-1">3</Badge>
                <div>
                  <p className="font-medium">Правильная цена</p>
                  <p className="text-sm text-gray-600">Изучите цены похожих документов</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Badge className="bg-orange-100 text-orange-800 border-orange-200 mt-1">4</Badge>
                <div>
                  <p className="font-medium">Подробное описание</p>
                  <p className="text-sm text-gray-600">Объясните, для чего нужен документ</p>
                </div>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default DocumentUpload;
